/**
 * =========================================================================================
 * Billing Payments - Filter Component
 * =========================================================================================
 */

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAGINATION } from 'ubs-framework/v2/common/constant';
import { FilterSelect } from 'ubs-framework/v2/common/UFilters/FilterSelect/filter-select';
import { getKeyName } from 'ubs-framework/v2/common/function';
import UFilters from 'ubs-framework/v2/common/UFilters/UFilters/UFilters';
import UDateRangePicker from 'ubs-framework/v2/UDateRangePicker';

const PAYMENT_STATUS_OPTIONS = [
    { value: 'SUCCESS', label: 'Success' },
    { value: 'FAILED', label: 'Failed' },
    { value: 'CANCELLED', label: 'Cancelled' },
    { value: 'PENDING', label: 'Pending' },
];

const PAYMENT_TYPE_OPTIONS = [
    { value: 'INITIAL', label: 'Initial' },
    { value: 'PERIODIC', label: 'Periodic' },
    { value: 'PRORATION', label: 'Proration' },
];

const PaymentsFilter = () => {
    const DISPATCH = useDispatch();
    const _FILTER = useSelector(e => e?.filter?.billingPayments);

    const handleFilterChange = (value, name) => {
        DISPATCH({ type: 'SET_BILLING_PAYMENTS', payload: { currentPage: PAGINATION.CURRENT_PAGE, [name]: value } });
    };

    const handleDateChange = (e) => {
        DISPATCH({
            type: 'SET_BILLING_PAYMENTS',
            payload: {
                currentPage: PAGINATION.CURRENT_PAGE,
                fromDate: e?.startDate || null,
                toDate: e?.endDate || null,
            }
        });
    };

    return (
        <React.Fragment>

            <UFilters
                filters={
                    <React.Fragment>
                        <div className="u_filter u_filter-daterange">
                            <UDateRangePicker
                                filterName="Date"
                                maxDate={new Date()}
                                startDate={_FILTER?.fromDate}
                                endDate={_FILTER?.toDate}
                                onClose={handleDateChange}
                                isClearable={true}
                                calendarPosition="bottom right"
                                extraRanges={true}
                            />
                        </div>
                        <FilterSelect
                            params={{
                                options: PAYMENT_STATUS_OPTIONS,
                                value: getKeyName(PAYMENT_STATUS_OPTIONS, _FILTER?.status),
                                onChange: (e) => handleFilterChange(e?.value || null, 'status'),
                                isClearable: true,
                            }}
                            type="Status"
                        />
                        <FilterSelect
                            params={{
                                options: PAYMENT_TYPE_OPTIONS,
                                value: getKeyName(PAYMENT_TYPE_OPTIONS, _FILTER?.paymentType),
                                onChange: (e) => handleFilterChange(e?.value || null, 'paymentType'),
                                isClearable: true,
                            }}
                            type="Payment Type"
                        />
                    </React.Fragment>
                }
                offset={1200}
                filtersLength={_FILTER}
            />
        </React.Fragment>
    );
};

export default PaymentsFilter;
